import React, { Component } from 'react'
import { Modal } from 'hljd'
import styles from './style.module.less'
import store from '../store'
import { observer } from 'mobx-react'
import QRCode from 'qrcode.react'

@observer
export default class extends Component {
  render() {
    const { weiXinVisible, weiXinQrCode } = store

    const { money, checkApi } = this.props
    return (
      <Modal
        footer={null}
        width={690}
        visible={weiXinVisible}
        onCancel={store.close}
      >
        <div className={styles.modalbox}>
          <p className={styles.title}>微信支付</p>
          <div className={styles.inner}>
            <p style={{ margin: '25px 0 10px 0' }}>扫一扫付款(元)</p>
            <p className={styles.money}>{money}</p>
            <QRCode value={weiXinQrCode} size={180} />
            <div className={styles.tip}>
              使用<img src="http://qnm.hunliji.com/o_1botirh763s132sbfi10v119d18.png" />
              <span>微信支付</span>
              {/*或<img src="http://qnm.hunliji.com/o_1botirh766kp1o21k1g1nf1eg09.png" /><span>支付宝</span>扫码支付*/}
            </div>
            {/*<div>成功后即时到账，即可注册小程序</div>*/}
          </div>
          {!checkApi && (
            <div className={styles.btnClick}>
              <span className={styles.yes} onClick={store.payAlready}>
                已支付成功
              </span>
              <span className={styles.close} onClick={store.close}>
                关闭
              </span>
            </div>
          )}
        </div>
      </Modal>
    )
  }
}
